import React, { useState } from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';

import { env } from '~/commons/config';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import FileInput from '~/commons/components/FileInput.jsx';
import FileClick from '~/commons/components/FileClick.jsx';
import FileDrop from '~/commons/components/FileDrop.jsx';

const FormSubject = ({ subject }) => {
  const [value, setValue] = useState(subject.attachment);
  const [res, req] = useHttpStatus();

  const onFileAdd = async ([f]) => {
    setValue(f);
  };

  return (
    <div className="input-group">
      <div className="input-group-prepend">
        <span className="input-group-text">
          {env.subjects[subject.key]?.zhhk}
        </span>
      </div>
      <div className="form-control h-auto">
        <FileDrop className="" onDrop={onFileAdd}>
          <FileClick className="" onFile={onFileAdd}>
            <FileInput
              api={{ url: 'api/quiz/subjects/files' }}
              value={value}
              onChange={(v) => {
                setValue(v);
                req({
                  url: `api/quiz/subjects/${subject.key}`,
                  method: 'patch',
                  data: {
                    attachment: v ? v._id : null,
                  },
                });
              }}
            >
              Drop your file or <u>Browse</u>
            </FileInput>
          </FileClick>
        </FileDrop>
      </div>
      {res.status === 'success' && (
        <div className="input-group-append">
          <span className="input-group-text bg-white text-primary">
            <FA icon={faCheck} className="mr-2" />
            Saved
          </span>
        </div>
      )}
    </div>
  );
};

export default FormSubject;
